export const shareContent = (platform, title, description, url) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedDescription = encodeURIComponent(description);
  const text = `${title} - ${description}`;
  const encodedText = encodeURIComponent(text);

  const shareUrls = {
    whatsapp: `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`,
  };

  if (platform === 'copy') {
    navigator.clipboard.writeText(url);
    return 'copied';
  }

  // Open in new tab
  window.open(shareUrls[platform], '_blank', 'noopener,noreferrer,width=600,height=400');
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  // Parse the ISO date string - ensure UTC interpretation
  const date = new Date(dateString);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) return '';
  
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  // Handle future dates or very recent timestamps
  if (diffSecs < 0) return 'Just now';
  if (diffSecs < 60) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const getImageUrl = (url) => {
  if (!url) return null;
  // If it's already a full URL, return as-is
  if (url.startsWith('http')) return url;
  // Otherwise prepend the backend URL
  const apiUrl = process.env.REACT_APP_BACKEND_URL || '';
  return `${apiUrl}${url}`;
};
